import { fetchWithCache, getCachedData } from "../services/apiService";

export const soldProperties = async ({ setProperties }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/propertySold", {});
  if (cached) {
    setProperties(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/property/propertySold",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setProperties(Array.isArray(data) ? data : []);
  } catch (error) {
    if (!cached) {
      setProperties([]);
    }
  }
};
